import Actions from '../../odata/actions';

const actions = new Actions('xeroTenant', 'xeroTenants');

export default actions;
